import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconDemandChart = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => {
  return (
    <svg width="174" height="50" viewBox="0 0 174 50" fill="none" {...props} ref={ref}>
      <g clipPath="url(#clip0_3862_9944)">
        <mask id="path-1-inside-1_3862_9944" fill="white">
          <path d="M6.10352e-05 0H58.0001V50H6.10352e-05V0Z" />
        </mask>
        <path d="M6.10352e-05 0H58.0001V50H6.10352e-05V0Z" fill="url(#paint0_linear_3862_9944)" />
        <path
          d="M6.10352e-05 1H58.0001V-1H6.10352e-05V1Z"
          fill="#3788F7"
          mask="url(#path-1-inside-1_3862_9944)"
        />
        <mask id="path-3-inside-2_3862_9944" fill="white">
          <path d="M58.0001 25H116V50H58.0001V25Z" />
        </mask>
        <path d="M58.0001 25H116V50H58.0001V25Z" fill="url(#paint1_linear_3862_9944)" />
        <path
          d="M58.0001 26H116V24H58.0001V26Z"
          fill="#3788F7"
          mask="url(#path-3-inside-2_3862_9944)"
        />
        <mask id="path-5-inside-3_3862_9944" fill="white">
          <path d="M116 42H174V50H116V42Z" />
        </mask>
        <path d="M116 42H174V50H116V42Z" fill="url(#paint2_linear_3862_9944)" />
        <path d="M116 43H174V41H116V43Z" fill="#3788F7" mask="url(#path-5-inside-3_3862_9944)" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3862_9944"
          x1="29.0001"
          y1="50"
          x2="29.0001"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#A3D3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3862_9944"
          x1="87.0001"
          y1="50"
          x2="87.0001"
          y2="25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#A3D3FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3862_9944"
          x1="145"
          y1="50"
          x2="145"
          y2="42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#A3D3FF" />
        </linearGradient>
        <clipPath id="clip0_3862_9944">
          <rect width="173.333" height="50" fill="white" transform="translate(0.333313)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDemandChart = forwardRef(_IconDemandChart)
